var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("nav", { staticClass: "level" }, [
        _c("div", { staticClass: "level-left" }),
        _c("div", { staticClass: "level-right" }, [
          _c("div", { staticClass: "level-item buttons" }, [
            _vm.canEdit()
              ? _c(
                  "button",
                  {
                    staticClass: "button is-primary",
                    on: {
                      click: function($event) {
                        return _vm.handleOpenModalUpsert()
                      }
                    }
                  },
                  [
                    _c("b-icon", { attrs: { icon: "plus" } }),
                    _c("span", [_vm._v(_vm._s(_vm.$t("button.add")))])
                  ],
                  1
                )
              : _vm._e()
          ])
        ])
      ]),
      _c(
        "b-table",
        {
          attrs: {
            data: _vm.isLoading ? [] : _vm.widgetSettingsData,
            narrowed: true,
            paginated: false,
            "per-page": _vm.pageFilters.perPage,
            striped: true,
            hoverable: true,
            "current-page": _vm.pageFilters.currentPage,
            "pagination-size": "is-small",
            "default-sort": _vm.tableSortSettings,
            draggable: "",
            "aria-next-label": "Next page",
            "aria-previous-label": "Previous page",
            "aria-page-label": "Page",
            "aria-current-label": "Current page"
          },
          on: {
            "update:perPage": function($event) {
              return _vm.$set(_vm.pageFilters, "perPage", $event)
            },
            "update:per-page": function($event) {
              return _vm.$set(_vm.pageFilters, "perPage", $event)
            },
            "update:currentPage": function($event) {
              return _vm.$set(_vm.pageFilters, "currentPage", $event)
            },
            "update:current-page": function($event) {
              return _vm.$set(_vm.pageFilters, "currentPage", $event)
            },
            dragstart: _vm.dragstart,
            drop: _vm.drop,
            dragover: _vm.dragover,
            dragleave: _vm.dragleave
          }
        },
        [
          _vm._t("columns"),
          _c("b-table-column", {
            attrs: {
              field: "feature",
              label: _vm.$t("label.feature"),
              sortable: "",
              width: "128"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("widget_setting." + props.row.feature)) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: {
              field: "width",
              label: _vm.$t("label.width"),
              sortable: ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [_vm._v(_vm._s(props.row.width || "-"))]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: {
              field: "height",
              label: _vm.$t("label.height"),
              sortable: ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [_vm._v(_vm._s(props.row.height || "-"))]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: {
              field: "order",
              label: _vm.$t("label.order"),
              sortable: ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [_vm._v(" " + _vm._s(props.row.order || "-") + " ")]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: { width: "100", field: "edit", label: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _vm.canEdit()
                      ? _c(
                          "button",
                          {
                            staticClass: "button is-text is-action",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.handleOpenModalUpsert(props.row)
                              }
                            }
                          },
                          [
                            _c("b-icon", {
                              attrs: {
                                size: "is-small",
                                icon: "circle-edit-outline"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.canDelete()
                      ? _c(
                          "button",
                          {
                            staticClass: "button is-text is-action",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.confirmSingleDelete(props.row._id)
                              }
                            }
                          },
                          [
                            _c("b-icon", {
                              attrs: { size: "is-small", icon: "delete" }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          !_vm.isLoading
            ? _c("template", { slot: "empty" }, [_c("NotFound")], 1)
            : _vm._e()
        ],
        2
      ),
      _vm.widgetSettingsData.length && _vm.widgetSettingsData.length >= 2
        ? _c("span", { staticClass: "is-size-7 pt-2" }, [
            _vm._v("(*) " + _vm._s(_vm.$t("messages.can_dnd_order")))
          ])
        : _vm._e(),
      _c("b-loading", {
        attrs: { "is-full-page": true, active: _vm.isLoading },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }